/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Group_AgentsInputs */

const en_hub_group_agents = /** @type {(inputs: Hub_Group_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coding agents`)
};

const id_hub_group_agents = /** @type {(inputs: Hub_Group_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen coding`)
};

/**
* | output |
* | --- |
* | "Coding agents" |
*
* @param {Hub_Group_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_group_agents = /** @type {((inputs?: Hub_Group_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Group_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_group_agents(inputs)
	return en_hub_group_agents(inputs)
});